import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGlobal } from "context/GlobalContext";
import { useAuth } from "context/AuthContext";
import { paginatorArray } from "utils/helpers/paginatorArray";
import { PAGE_SIZE_OPTIONS } from "utils/helpers/list/pageSize";
import { setStoredListPageSize } from "utils/helpers/list/listPageSize";
import { memo } from "react";

const Paginator = memo(({paginator, onChangePage = null, onChangeOnPage = null, storageKey = null, showPageSize = true}) => { 

    const { g } = useGlobal();
    const { auth } = useAuth();
    const { t } = useTranslation('common');
    const location = useLocation();
    const pageSizeKey = storageKey || location.pathname;

    const aPaginator = paginatorArray(
        paginator.countPages||1,
        paginator.currentPage
    );
      
    const handlePageClick = (page) => {
        if (onChangePage) return onChangePage(page);
        paginator.currentPage = page;
        g.setPaginator((prev)=>({
            ...prev,
            [location.pathname] : paginator
        }))
    }

    const handlePageSizeChange = (event) => {
        const nextOnPage = parseInt(event.target.value, 10);
        if (!PAGE_SIZE_OPTIONS.includes(nextOnPage)) return;

        if (auth?.user?.ID) {
            setStoredListPageSize(auth.user.ID, pageSizeKey, nextOnPage);
        }

        if (onChangeOnPage) {
            onChangeOnPage(nextOnPage);
            return;
        }

        g.setPaginator((prev) => ({
            ...prev,
            [location.pathname]: {
                ...prev?.[location.pathname],
                ...paginator,
                onPage: nextOnPage,
                currentPage: 1,
            },
        }));
    };
 
    return (  
        <>
        {paginator &&
        (<div className="paginator-toolbar d-flex flex-nowrap align-items-center justify-content-between gap-1 w-100">
            {showPageSize && (
                <div className="paginator-page-size d-flex align-items-center flex-shrink-0">
                    <label
                        htmlFor="paginator-page-size-select"
                        className="paginator-page-size-label text-muted small mb-0"
                    >
                        {t('paginator.rowsPerPage')}
                    </label>
                    <select
                        id="paginator-page-size-select"
                        className="form-select form-select-sm paginator-page-size-select"
                        aria-label={t('paginator.rowsPerPage')}
                        value={paginator.onPage}
                        onChange={handlePageSizeChange}
                    >
                        {PAGE_SIZE_OPTIONS.map((size) => (
                            <option key={size} value={size}>{size}</option>
                        ))}
                    </select>
                </div>
            )}

            <nav aria-label="Page navigation example" className="paginator-nav ms-auto">
                <ul className="pagination paginator-pages mb-0 justify-content-end flex-nowrap">
                    
                    <li className="page-item">
                        <span className="page-link" 
                            onClick={()=>handlePageClick(1)}>
                            <span aria-hidden="true">«</span>
                        </span>
                    </li>

                    {aPaginator.map(page=>{
                        const pageTitle = (page>=0) ? page+1 : '...'
                        const pageIndex = Math.abs(page)+1;
                         /*
                        const pageClass = ((page + 1 === paginator.currentPage) || 
                                            ((page===0) && (paginator.currentPage<0)))  ? 'page-item active' : 'page-item';
                                            
                        */
                        const pageClass = ((page + 1 === paginator.currentPage) )  ? 'page-item active' : 'page-item';                  

                        return (
                            <li key={`paginatorPage-${page}`} 
                                className={pageClass}>
                                <span  className="page-link cursor-pointer"
                                    onClick={()=>handlePageClick(pageIndex)}>{pageTitle}</span>
                            </li>
                        )
                    })}

                    <li className="page-item">
                        <span className="page-link" 
                            onClick={()=>handlePageClick(paginator.countPages)}>
                            <span aria-hidden="true">»</span>
                        </span>            
                    </li>

                </ul>
            </nav>
        </div>)}
        </>
        
    );
},  (prevProps, nextProps) =>{
    return (nextProps.paginator?.currentPage ===-1)
})

export default Paginator;
